export const FIRMWARE_AP_IMAGES_SECTION_EVENT =
	'canvas-agent:firmware:ap-images-section';
export const FIRMWARE_AP_TASKS_SECTION_EVENT =
	'canvas-agent:firmware:ap-tasks-section';
export const FIRMWARE_SWITCH_IMAGES_SECTION_EVENT =
	'canvas-agent:firmware:switch-images-section';

// The three Add forms live on the page that owns the accordions, because that
// is where their open flags are kept.
export const FIRMWARE_ADD_AP_IMAGE_MODAL_EVENT =
	'canvas-agent:firmware:add-ap-image-modal';
export const FIRMWARE_ADD_AP_TASK_MODAL_EVENT =
	'canvas-agent:firmware:add-ap-task-modal';
export const FIRMWARE_ADD_SWITCH_IMAGE_MODAL_EVENT =
	'canvas-agent:firmware:add-switch-image-modal';

/**
 * The events each list listens for, by the kind of row it holds.
 *
 * Three lists means three of everything, and the kind is also the
 * `resource` the backend puts on an `apply_filter` or `focus_entity`
 * command - so the same key picks the event here, the resolver in
 * `resolver.js` and the handler in `plugin.js`. A list hears only its own
 * events: sharing one event name across them would make the Switch list
 * answer a filter meant for the Access Point list, and whichever answered
 * first would be the one the agent believed.
 */
export const FIRMWARE_LIST_EVENTS = {
	ap_firmware: {
		filter: 'canvas-agent:firmware:ap-images-filter',
		focus: 'canvas-agent:firmware:ap-images-focus',
		upgrade: 'canvas-agent:firmware:ap-images-upgrade-modal',
		delete: 'canvas-agent:firmware:ap-images-delete-modal',
	},
	ap_firmware_task: {
		filter: 'canvas-agent:firmware:ap-tasks-filter',
		focus: 'canvas-agent:firmware:ap-tasks-focus',
		edit: 'canvas-agent:firmware:ap-tasks-edit-modal',
		delete: 'canvas-agent:firmware:ap-tasks-delete-modal',
	},
	switch_firmware: {
		filter: 'canvas-agent:firmware:switch-images-filter',
		focus: 'canvas-agent:firmware:switch-images-focus',
		upgrade: 'canvas-agent:firmware:switch-images-upgrade-modal',
		delete: 'canvas-agent:firmware:switch-images-delete-modal',
	},
};
